module.exports = __webpack_public_path__ + "static/img/zhifubao.be38b146.png";